{
  "config": {
    "page_title": "Hello AI",
    "showThoughtProcess": true,
    "isDev": true,
    "showShouldStream": true,
    "segment_demo_data": true,
    "colors": {
      "light": {
        "--background": "0 0% 100%",
        "--foreground": "197 6% 22%",
        "--card": "0 0% 100%",
        "--card-foreground": "197 6% 22%",
        "--popover": "0 0% 100%",
        "--popover-foreground": "197 6% 22%",
        "--primary": "196 100% 83%",
        "--primary-foreground": "197 6% 22%",
        "--primary-ink": "197 6% 22%",
        "--primary-tint": "196 100% 92%",
        "--secondary": "196 100% 92%",
        "--secondary-foreground": "197 6% 22%",
        "--muted": "48 13% 84%",
        "--muted-foreground": "200 4% 32%",
        "--accent": "196 100% 92%",
        "--accent-foreground": "197 6% 22%",
        "--destructive": "10 100% 87%",
        "--destructive-foreground": "197 6% 22%",
        "--destructive-ink": "9 50% 47%",
        "--warning": "56 100% 78%",
        "--warning-foreground": "197 6% 22%",
        "--warning-ink": "48 100% 27%",
        "--success": "98 81% 73%",
        "--success-foreground": "197 6% 22%",
        "--success-ink": "100 62% 24%",
        "--border": "48 13% 84%",
        "--input": "48 13% 84%",
        "--ring": "197 6% 22%",
        "--chart-1": "196 100% 83%",
        "--chart-2": "308 100% 94%",
        "--chart-3": "56 100% 78%",
        "--chart-4": "40 11% 74%",
        "--chart-5": "48 13% 84%",
        "--chart-foreground": "197 6% 22%",
        "--sidebar-background": "0 0% 100%",
        "--sidebar-foreground": "197 6% 22%",
        "--sidebar-primary": "196 100% 83%",
        "--sidebar-primary-foreground": "197 6% 22%",
        "--sidebar-accent": "196 100% 92%",
        "--sidebar-accent-foreground": "197 6% 22%",
        "--sidebar-border": "48 13% 84%",
        "--sidebar-ring": "197 6% 22%",
        "--scrollbar-track": "0 0% 100%",
        "--scrollbar-thumb": "48 13% 84%",
        "--scrollbar-thumb-hover": "40 11% 74%",
        "--radius": "0.75rem",
        "--chat-box": "0 0% 100%"
      },
      "dark": {
        "--background": "200 6% 10%",
        "--foreground": "30 50% 98%",
        "--card": "200 6% 10%",
        "--card-foreground": "30 50% 98%",
        "--popover": "195 6% 13%",
        "--popover-foreground": "30 50% 98%",
        "--primary": "196 100% 83%",
        "--primary-foreground": "197 6% 22%",
        "--primary-ink": "196 100% 83%",
        "--primary-tint": "196 30% 18%",
        "--secondary": "197 6% 22%",
        "--secondary-foreground": "30 50% 98%",
        "--muted": "197 6% 22%",
        "--muted-foreground": "40 11% 74%",
        "--accent": "200 4% 32%",
        "--accent-foreground": "30 50% 98%",
        "--destructive": "9 100% 77%",
        "--destructive-foreground": "197 6% 22%",
        "--destructive-ink": "9 100% 77%",
        "--warning": "56 100% 78%",
        "--warning-foreground": "197 6% 22%",
        "--warning-ink": "56 100% 78%",
        "--success": "98 81% 73%",
        "--success-foreground": "197 6% 22%",
        "--success-ink": "98 81% 73%",
        "--border": "197 6% 22%",
        "--input": "197 6% 22%",
        "--ring": "196 100% 83%",
        "--chart-1": "196 100% 83%",
        "--chart-2": "308 100% 94%",
        "--chart-3": "56 100% 78%",
        "--chart-4": "40 11% 74%",
        "--chart-5": "195 2% 53%",
        "--chart-foreground": "197 6% 22%",
        "--sidebar-background": "195 6% 13%",
        "--sidebar-foreground": "30 50% 98%",
        "--sidebar-primary": "196 100% 83%",
        "--sidebar-primary-foreground": "197 6% 22%",
        "--sidebar-accent": "200 4% 32%",
        "--sidebar-accent-foreground": "30 50% 98%",
        "--sidebar-border": "197 6% 22%",
        "--sidebar-ring": "196 100% 83%",
        "--scrollbar-track": "195 6% 13%",
        "--scrollbar-thumb": "197 6% 22%",
        "--scrollbar-thumb-hover": "200 4% 32%",
        "--radius": "0.75rem",
        "--chat-box": "200 7% 16%"
      }
    }
  }
}
